import { queryClient } from '@/lib/queryClient';
/**
 * React Query key for `GET /users/me/preferences`. Lives here (not in the
 * hook) so plain API helpers can read the shared cache without importing the
 * hook, which would pull the API barrel back in and close an import cycle.
 * `useUserPreferences` re-exports it for its existing consumers.
 */
export const USER_PREFERENCES_QUERY_KEY = ['userPreferences'];
/**
 * The stored preference as a column count, or undefined for "follow the
 * report design" (the server default, `null`).
 */
export function toPdfImageColumns(pref) {
    if (pref === '1')
        return 1;
    if (pref === '2')
        return 2;
    return undefined;
}
/**
 * The signed-in user's column preference, read from the shared preferences
 * cache; undefined when unset or not loaded yet. This is how plain fetchers
 * (`getStandardReportPdfBlob`, `getTcReportPdfBlob`) inherit the preference, so a
 * worklist row, a TC dialog and the editor all download the same PDF the
 * preview modal showed, without threading a hook value through every caller.
 */
export function readPdfImageColumnsPreference() {
    const prefs = queryClient.getQueryData(USER_PREFERENCES_QUERY_KEY);
    return toPdfImageColumns(prefs?.reportSettings?.pdfImageColumns);
}
/**
 * Query-string suffix for the PDF endpoints (`?imageColumns=2`), or '' to let
 * the server follow the report design.
 */
export function pdfImageColumnsQuery(columns) {
    return columns ? `?imageColumns=${columns}` : '';
}
